import { render, staticRenderFns } from "./Examiner.vue?vue&type=template&id=38f19e1a"
import script from "./Examiner.vue?vue&type=script&lang=js"
export * from "./Examiner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports